<template>
  <div id="appLoginVueComponent">
    <div class="appLogoStyle1">
      <img src="../../assets/Logo1.png" alt="logo de Privilégia Coiffure" class="appLoginLogo">
    </div>
    <div id="appLoginDiv">
      <div class="appInputStyleMain">
        <label for="email" class="appLabelStyle1">Email</label>
        <br>
        <input v-model="email" type="email" name="email" class="appInputStyle1" placeholder="Renseigner mon email ici">
      </div>
      <div class="appInputStyleMain">
        <label for="password" class="appLabelStyle1">Mot de passe</label>
        <br>
        <input v-model="password" type="password" name="password" class="appInputStyle1" placeholder="**********">
      </div>
      <div class="appButtonStyleMain">
        <button @click.prevent="userLogin()" type="submit" class="appButtonModel1">Se connecter</button>
      </div>
      <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      errorMsg: ''
    }
  },
  methods: {
    userLogin () {
      // Test si valeurs vides
      if (this.email !== null || this.password !== null) {
        this.errorMsg = ''
        // Si champs tous remplis
        Axios
          .post('https://privilegia.fr/api/users/login', {
            email: this.email,
            password: this.password
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {
            const userPrivilegia = {
              token: response.data.token
            }
            localStorage.setItem('userPrivilegia', JSON.stringify(userPrivilegia))
            this.$router.push('/App/Home')
            // On rafraichit pour permettre d'actualiser la visibilité des menus
            // location.reload()
          })
          .catch(() => {
            this.loading = false
            this.errorMsg = 'Email/Mot de passe invalide'
          })
          // Si champs non remplis
      } else {
        this.errorMsg = 'Merci de renseigner un Email/Mot de passe'
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppLogin.vue